import { render } from "./AddDish.vue?vue&type=template&id=5fe3fa07&scoped=true"
import script from "./AddDish.vue?vue&type=script&lang=js"
export * from "./AddDish.vue?vue&type=script&lang=js"

import "./AddDish.vue?vue&type=style&index=0&id=5fe3fa07&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe3fa07"]])

export default __exports__